<template>
  <div>
    <component
      v-model="fieldValue"
      :is="fieldComponent"
      :item="basicDataItem"
      :autofill="getAutofillAttribute(basicDataItem)"
    ></component>
  </div>
</template>

<script>
import { autofillMixin } from '@/mixins/autofill.js';

import fieldTypeEnums from '@/enum/application-field-type.js';
import textField from '@/components/application/basic-data/text-field.vue';
import textareaField from '@/components/application/basic-data/textarea-field.vue';
import numericField from '@/components/application/basic-data/numeric-field.vue';
import dateField from '@/components/application/basic-data/date-field.vue';
import selectField from '@/components/application/basic-data/select-field.vue';
import salaryField from '@/components/application/basic-data/salary-field.vue';
import rangeField from '@/components/application/basic-data/range-field.vue';
import yesnoField from '@/components/application/basic-data/yesno-field.vue';

export default {
  mixins: [autofillMixin],
  props: {
    value: {
      type: [String, Number],
      required: true
    },

    basicDataItem: {
      type: Object,
      required: true
    }
  },

  computed: {
    fieldType() {
      return fieldTypeEnums.ApplicationFieldTypes;
    },

    fieldValue: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('input', val);
      }
    },

    fieldComponent() {
      switch (this.basicDataItem.fieldType) {
        case this.fieldType.Text:
        case this.fieldType.Url:
        case this.fieldType.Skype:
          return 'textField';
        case this.fieldType.Textarea:
          return 'textareaField';
        case this.fieldType.Numeric:
          return 'numericField';
        case this.fieldType.Date:
          return 'dateField';
        case this.fieldType.Select:
          return 'selectField';
        case this.fieldType.Salary:
          return 'salaryField';
        case this.fieldType.Range:
          return 'rangeField';
        case this.fieldType.Checkbox:
          return 'yesnoField';
      }

      return '';
    }
  },

  components: {
    dateField,
    textField,
    textareaField,
    numericField,
    selectField,
    salaryField,
    rangeField,
    yesnoField
  }
};
</script>
